import { lazy, Suspense } from "react";
import styled from "styled-components";
import { Helmet } from "react-helmet";
import { AccessibilityWidget } from "react-accessibility";
import Head from "./Head";
import Office from "./components/questions";
import { About } from "./components/About";
import { Icons } from "./components/Icons";
import { TopSection } from "./components/topSection";
import { TopSection3 } from "./components/topSection3";
import { Contact } from "./Sections/contact";
import CookieConsent from "./CookieConsent";
import WhatsAppBot from "./WhatsAppBot";
import Adsense from "./Adsense";
import "./App.css";

/* =====================================================
   LAZY COMPONENTS
===================================================== */

const Home = lazy(() => import("./Pages/Home"));
const Header = lazy(() => import("./components/Header/index"));

/* =====================================================
   APP BACKGROUND
===================================================== */

const Styleapp = styled.div`
  width: 100%;
  min-height: 100vh;
  background: #081a2f;

`;

/* =====================================================
   ADSENSE
===================================================== */

const AdsWrapper = styled.div`
  width: 100%;

  display: flex;
  justify-content: center;
  align-items: center;

  overflow: hidden;

  margin: 0;
  padding: 0;

  ins.adsbygoogle {
    display: block !important;

    width: 100% !important;
    max-width: 100% !important;

    margin: 0 !important;
    padding: 0 !important;

    min-height: 0 !important;
    height: auto !important;

    line-height: 0;
  }
`;

/* =====================================================
   SEO
===================================================== */

const seo = {
  title:
    "ניקיון משרדים מקצועי לעסקים | SG1 - חברת ניקיון ואחזקות בישראל",

  description:
    "SG1 מספקת שירותי ניקיון משרדים, אחזקת מבנים וניקיון לעסקים בכל רחבי ישראל. שירות מקצועי, אמינות גבוהה והתאמה מלאה לצרכי העסק שלך.",

  keywords:
    "ניקיון משרדים, חברת ניקיון, ניקיון לעסקים, אחזקת מבנים, ניקיון משרדים פתח תקווה, חברת ניקיון בישראל, שירותי ניקיון לעסקים",

  url: "https://sg1.co.il/",

  image: "https://sg1.co.il/logo192.jpeg",

  siteName: "SG1 ניקיון ואחזקות",

  locale: "he_IL",
};

/* =====================================================
   APP
===================================================== */

function App() {
  const landingPageData = {};

  return (
    <Styleapp>

      {/* =================================================
          SEO
      ================================================= */}

      <Helmet>

        <title>{seo.title}</title>

        <meta
          name="description"
          content={seo.description}
        />

        <meta
          name="keywords"
          content={seo.keywords}
        />

        <meta
          name="robots"
          content="index, follow"
        />

        <meta
          name="viewport"
          content="width=device-width, initial-scale=1"
        />

        <link
          rel="canonical"
          href={seo.url}
        />

        {/* Open Graph */}

        <meta
          property="og:title"
          content={seo.title}
        />

        <meta
          property="og:description"
          content={seo.description}
        />

        <meta
          property="og:image"
          content={seo.image}
        />

        <meta
          property="og:url"
          content={seo.url}
        />

        <meta
          property="og:type"
          content="website"
        />

        <meta
          property="og:site_name"
          content={seo.siteName}
        />

        <meta
          property="og:locale"
          content={seo.locale}
        />

        {/* Twitter */}

        <meta
          name="twitter:card"
          content="summary_large_image"
        />

        <meta
          name="twitter:title"
          content={seo.title}
        />

        <meta
          name="twitter:description"
          content={seo.description}
        />

        <meta
          name="twitter:image"
          content={seo.image}
        />

      </Helmet>


      {/* =================================================
          CONTENT
      ================================================= */}

      <Suspense
        fallback={
          <div
            style={{
              minHeight: "100vh",
              background: "#081a2f",
            }}
          />
        }
      >

        {/* מערכת אייקונים */}
        <Icons />

        {/* WhatsApp */}
        <WhatsAppBot />

        {/* נגישות */}
        <AccessibilityWidget />

        {/* Cookies */}
        <CookieConsent />


        {/* Header */}
        <Header
          data={landingPageData.Features}
        />


        {/* Hero / Head */}
        <Head
          data={landingPageData.Features}
        />


        {/* שאלות / מידע */}
        <Office
          data={landingPageData.Features}
        />


        {/* Home */}
        <Home
          data={landingPageData.Features}
        />


        {/* About */}
        <About
          data={landingPageData.Features}
        />


        {/* Sections */}
        <TopSection
          data={landingPageData.Features}
        />

        <TopSection3
          data={landingPageData.Features}
        />


        {/* Footer */}
        <Contact
          data={landingPageData.Features}
        />


        {/* =================================================
            ADSENSE - בסוף העמוד
        ================================================= */}

        <AdsWrapper>
<Adsense />
        </AdsWrapper>

      </Suspense>

    </Styleapp>
  );
}

export default App;
